var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between items-center"},[_c('strong',{staticClass:"md:hidden"},[_vm._t("header")],2),_vm._v(" "),_vm._t("value")],2)}
var staticRenderFns = []

export { render, staticRenderFns }